export default "__VITE_ASSET__af72bb09__"